import styled from "styled-components";

export const TextoDescricao = styled.p`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.neutral.neutral70};
  margin-bottom: 1rem;
`;

export const ContainerBotoes = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
`;

export const CaixaCampos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
  border-radius: 8px;
`;
